<template>
  <div class="content" v-show="loading">
    <div class="nav-tab">
      <mt-navbar v-model="selected">
        <mt-tab-item id="1">{{ $t('message.repay.car') }}</mt-tab-item>
        <span class="center-line"></span>
        <mt-tab-item id="2">{{ $t('message.repay.insurance') }}</mt-tab-item>
      </mt-navbar>
    </div>
    <div class="list-container">
      <change-language />
      <div class="list" @click="gotoDetail(obj)" v-for="(obj, index) in orderList" :key="index">
        <repay-item :order="obj"></repay-item>
      </div>
      <div v-if="!orderList.length" class="none">
        {{ $t('message.repay.no_pay_records') }}
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import ChangeLanguage from '@/views/pages/app/common/change-language';
import repayItem from './component/repay-item';
import { getAutoOrder } from '../api/index.js';
import { setCToken } from '@/utils/auth';
export default {
  name: 'repayList',
  components: {
    repayItem,
    ChangeLanguage
  },
  data () {
    return {
      selected: '1',
      loading: false,
      orderList: [{ 1: 1 }]
    };
  },
  watch: {
    selected (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getAutoOrder();
      }
    }
  },
  methods: {
    gotoDetail (obj) {
      if (/0|2/.test(obj.repaymentStatus)) {
        this.$router.push(`/repay/pay?orderId=${obj.orderId}&repaymentStatus=${obj.repaymentStatus}&title=${obj.autoModelTitle}`);
      } else {
        this.$router.push(`/repay/account?orderId=${obj.orderId}&repaymentStatus=${obj.repaymentStatus}&title=${obj.autoModelTitle}`);
      }
    },
    async getAutoOrder () {
      const params = {
        type: Number(this.selected),
        pageNum: 1,
        pageSize: 100
      };
      try {
        const res = await getAutoOrder(params);
        if (res.data.errcode === 200 || res.data.errcode === 'SUCCESS') {
          this.loading = true;
          this.orderList = res.data.data || [];
        } else {
          Toast(res.data.msg);
        }
      } catch (e) {
        if (e.response.status === 401 || e.response.status === 403 || e.response.status === 456) {
          // 身份认证信息未提供
          Toast(this.$t('message.repay.no_auth_toast'));
          setCToken('');
          this.$router.push({ path: '/clogin' });
        }
      }
    },
    getAll () {
      getAutoOrder({ type: 1, pageNum: 1, pageSize: 100 }).then(res => {
        if (res.data.errcode === 200 || res.data.errcode === 'SUCCESS') {
          const first_list = res.data.data || [];
          getAutoOrder({ type: 2, pageNum: 1, pageSize: 100 }).then(res => {
            if (res.data.errcode === 200 || res.data.errcode === 'SUCCESS') {
              const second_list = res.data.data || [];
              const list = [].concat(first_list, second_list);
              const obj = list[0];
              if (list.length === 1 && /0|2/.test(obj.repaymentStatus)) {
                this.$router.push(`/repay/pay?orderId=${obj.orderId}&repaymentStatus=${obj.repaymentStatus}&title=${obj.autoModelTitle}`);
              }
            }
          });
        }
      });
    }
  },
  destroyed () {
    sessionStorage.__load__repayList = 'true';
  },
  created () {
    sessionStorage.__load__repayList === undefined && this.getAll();
    this.getAutoOrder();
  }
};
</script>
<style lang="scss">
  .mint-navbar {
    color: #7F7F7F;
    .mint-tab-item {
      padding: 0px;
    }
    .mint-tab-item.is-selected {
      color: #000000;
      border-bottom: 0px;
      .mint-tab-item-label {
        border-bottom: 2px solid #FFE102;
      }
    }
    .mint-tab-item-label {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      padding: 17px 0;
      width: 80px;
      margin: 0 auto;
      white-space: nowrap;
    }
    .center-line {
      display: inline-block;
      width: 1px;
      height: 30px;
      margin-top: 10px;
      background-color: #DFDFDF;
    }
  }
</style>
<style scoped lang="scss">
.content {
  height: 100%;
  position: relative;
  .nav-tab {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
  }
  .list-container {
    padding-top: 110px;
    .list {
      padding-top: 30px;
    }
    .none {
      font-family: PingFangSC-Regular;
      font-size: 30px;
      color: #7f7f7f;
      text-align: center;
      padding-top: 50%;
    }
  }
}
</style>
